import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-[4px] tw-font-medium tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring disabled:tw-pointer-events-none disabled:tw-opacity-50",
  {
    variants: {
      variant: {
        default:
          "tw-bg-[#00B5ED] tw-text-primary-foreground tw-shadow hover:tw-bg-[#00a3d5]",
        darkbg:
          "tw-bg-transparent tw-text-sm tw-text-white hover:tw-text-[#00a3d5]",
        destructive:
          "tw-bg-destructive tw-text-destructive-foreground tw-shadow-sm hover:tw-bg-destructive/90",
        outline:
          "tw-border tw-border-input tw-bg-background tw-shadow-sm hover:tw-bg-accent hover:tw-text-accent-foreground",
        secondary:
          "tw-bg-secondary tw-text-secondary-foreground tw-shadow-sm hover:tw-bg-secondary/80",
        disabled: "tw-bg-gray-300 tw-text-primary-foreground tw-shadow ",
        ghost:
          "tw-text-[#00B5ED] hover:tw-bg-accent hover:tw-text-accent-foreground",
        link: "tw-text-primary tw-underline-offset-4 hover:tw-underline",
        calender:
          "tw-bg-[#00B5ED]/40 tw-text-black tw-shadow hover:tw-bg-[#00a3d5]",
        mobilemenu:
          "tw-bg-[#00B5ED] tw-font-normal tw-text-primary-foreground hover:tw-bg-[#00a3d5] hover:tw-text-[#00B5ED] hover:tw-bg-transparent tw-bg-transparent focus:tw-bg-transparent tw-px-6 tw-py-2 tw-rounded tw-text-white",
      },
      size: {
        default: "tw-h-9 tw-px-4 tw-py-2",
        sm: "tw-h-8 tw-rounded-md tw-px-3 tw-text-xs",
        lg: "tw-h-10 tw-rounded-md tw-px-8",
        xl: "tw-h-12 tw-rounded-md tw-px-12 tw-text-xl",
        steps: "tw-h-14 tw-rounded-md tw-w-64 md:tw-w-96 tw-px-16 md:tw-px-52",
        icon: "tw-h-9 tw-w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
